<template>
  <div id="v3CashOutDiv">
    <div id="v3CashOutContentDiv">
      <div id="v3ArrowDiv" @click="onBackClick()"><img id="v3Arrow" src="~assets/img/SdkV3/ArrowLeft.png" /></div>
      <div id="v3RecordDiv" @click="onRecordClick()"><img id="v3Record" src="~assets/img/SdkV3/Record.png" /></div>
      <div id="v3codTitleDiv">
        红包兑换
      </div>
      <div id="cashoutListDiv">
        <div style="float: left; margin-right: 10px;" v-for="(item, index) in cashOutMoneyList" :key="index">
          <CashoutItem :item="item" :selected="currentIndex === index" :index="index"
            @setClickItemCallback="setClickItemCallback"></CashoutItem>
        </div>
      </div>
      <HR style="border:1 dashed #987cb9;" width="95%" color=#E4E4E4 SIZE=0.5>
      </HR>
      <div id="v3Cashouv3ipDiv">
        <span>温馨提示</span>
        <span>1，部分兑换档位有兑换次数限制;</span>
        <span>2，部分兑换档位需要满足等级和道具条件方可提现，点击档位查看详情;</span>
        <span>3，我们将在3个工作日内将您兑换的红包发放到您绑定的微信内，还请您留意兑换记录，若兑换失败请联系客服处理。</span>
      </div>
      <br>
      <button @click="onCashoutClick()">提 现</button>
    </div>
    <ReceiveLog v-show="showReceiveLog" :receiveLogs="receiveLogs" @hidereceivelogpage="hidereceivelogpage" />
    <ExchangeSuccess v-show="showExchangeSuccess" :exchangeSuccessItem="exchangeSuccessItem"
      @hideexchangesuccesspage="hideexchangesuccesspage" />
    <AlertConfirm v-if="$store.state.showAlert" />
  </div>
</template>

<script>
import CashoutItem from './CashoutItem.vue';
import ReceiveLog from './receivelog/V3ReceiveLog.vue';
import ExchangeSuccess from './ExchangeSuccess.vue';
import AlertConfirm from "views/SdkV3/AlertConfirm.vue";
import { request } from '@/network/request';
import getRequestParams from "@/signParams";
import urlencode from 'urlencode'
export default {
  props: {
    cashOutMoneyList: [],
    typeId: "",
  },
  data() {
    return {
      // list:[1,2,2,3,3],
      currentIndex: -1,
      handleExchange: false,// 是否正在处理兑换，避免多次点击兑换按钮,
      showReceiveLog: false, // 是否显示领取记录
      showExchangeSuccess: false, // 是否显示兑换成功页面
      receiveLogs: [],// 领取记录列表
      exchangeSuccessItem: null, //兑换成功后，返回的提示信息和验证码等信息
    }
  },
  components: {
    CashoutItem, ReceiveLog, AlertConfirm, ExchangeSuccess
  },
  methods: {
    hideexchangesuccesspage() {
      this.showExchangeSuccess = false;
    },
    hidereceivelogpage() {
      this.showReceiveLog = false;
    },
    onBackClick() {
      this.currentIndex = -1;
      this.$emit('closecashout')
    },
    onCashoutClick() {
      console.log("点击兑换", this.currentIndex);
      if (this.currentIndex === -1) {
        this.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "请先选择兑换档位" });
        return;
      }
      let selectedItem = this.cashOutMoneyList[this.currentIndex];
      let showSelectedExchangeMoney = selectedItem['money'];
      console.log("点击兑换1", showSelectedExchangeMoney);
      // console.log("调用兑换接口");
      if (showSelectedExchangeMoney == "0") {
        return;
      }
      console.log("点击兑换2", showSelectedExchangeMoney);
      if (this.handleExchange) {
        // console.log("正在处理兑换逻辑。。。不要那么急");
        return;
      }
      console.log("点击兑换3", this.handleExchange);
      // 调用兑换接口
      this.handleExchange = true;
      let storeCommomParams = this.$store.state.commonParameters
      let levelRebateReceiveReqParams = getRequestParams(
        { 
          "amount": showSelectedExchangeMoney,
           "bonus": selectedItem['bonus'] ,
           'typeid': this.typeId
          }, 
          storeCommomParams
          );
      request({
        url: this.urls.REBATE_EXCHANGE,
        params: {
          data: levelRebateReceiveReqParams
        },
      }).then(res => {
        this.handleExchange = false;
        console.log(res);
        this.$store.dispatch("networkExchange", res)
        // this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "兑换成功"});
        this.exchangeSuccessItem = res;
        this.showExchangeSuccess = true;

      }).catch(error => {
        console.log(error);
        this.handleExchange = false;
        let errorMessage = error["message"];
        console.log(errorMessage);
        // 该账号未绑定提取方式
        if (errorMessage.indexOf("该账号未绑定提取方式") != -1) {
          this.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "该账号未绑定提取方式" });
          this.wxBind();
          return
        }
        if (errorMessage.indexOf("5012") != -1) {
          // this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": errorMessage.replace("5012","")});
          this.$store.commit('switchAlert', { "showOrHide": true, "alertMessage": errorMessage.replace("5012", "") })
          return
        }
        this.$store.commit("switchToast", { "showOrHide": true, "toastMessage": errorMessage });
      });
    },
    // 微信未绑定，点击的时候显示微信二维码绑定页面
    wxBind() {
      // console.log("点击绑定微信");
      let storeCommomParams = this.$store.state.commonParameters
      // 这里显示绑定提取方式  ct=rebate&ac=wxAuth  获取微信绑定二维码展示
      let wxBindReqParams = getRequestParams({}, storeCommomParams);
      request({
        url: this.urls.REBATE_WXAUTH,
        params: {
          data: wxBindReqParams
        },
      }).then(res => {
        // console.log(res);
        // console.log(JSON.parse(res.param)['url']);
        if ("qrcode" == res.type) {
          let qrcodeUrl = JSON.parse(res.param)['url'];
          this.$store.dispatch('networkWxBindPageShow', { "showOrHide": true, "qrcodeUrl": qrcodeUrl })
        } else {
          this.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "暂无绑定方式" })
          this.$store.dispatch('networkWxBindPageShow', { "showOrHide": false, "qrcodeUrl": "" })
        }
      })
    },
    zfbBind() {
      let storeCommomParams = this.$store.state.commonParameters;
      // 这里显示绑定提取方式  ct=rebate&ac=wxAuth  获取微信绑定二维码展示
      let aliAuthReqParams = getRequestParams({}, storeCommomParams);
      request({
        url: this.urls.REBATE_ALIAUTH,
        params: {
          data: aliAuthReqParams
        },
      }).then(res => {
        // console.log(res);
        // console.log(JSON.parse(res.param)['url']);
        if ("1" == res.status) {// 授权已成功

        } else {
          let aliAuthUrl = res['url']
          this.sendToClient('openUrl?'.concat(JSON.stringify({ "url": "alipays://platformapi/startapp?appId=20000067&url=" + urlencode(aliAuthUrl) })))
        }
      })
    },

    setClickItemCallback(index) {
      this.currentIndex = index;
    },
    onRecordClick() {
      // 跳转
      // 先查询有没有记录
      let storeCommomParams = this.$store.state.commonParameters;
      let exchangeLogsReqReqParams = getRequestParams({}, storeCommomParams);
      let exchangeLogsReq = request({
        url: this.urls.REBATE_EXCHANGELOG,
        params: {
          data: exchangeLogsReqReqParams
        },
      });
      // 先查询有没有记录
      let receiveLogsReqReqParams = getRequestParams({}, storeCommomParams);
      let receiveLogsReq = request({
        url: this.urls.REBATE_RECEIVE_LOG,
        params: {
          data: receiveLogsReqReqParams
        },
      });
      Promise.all([receiveLogsReq, exchangeLogsReq]).then(values => {
        let receiveLogs = values[0];
        let exchangeLogs = values[1];
        console.log(receiveLogs);
        console.log(exchangeLogs);
        let receiveList = JSON.parse(receiveLogs.receiveLog);
        // console.log(receiveList);
        let exchangeList = JSON.parse(exchangeLogs.exchangeLog);
        if (exchangeList.length > 0) {
          // 遍历兑换列表数据，添加进领取的数组中去
          for (let index = 0; index < exchangeList.length; index++) {
            const element = exchangeList[index];
            element['typename'] = "现金兑换";
            receiveList.push(element);
          }
        }

        // 数字数组升序，降序的话就将后面的 a, b 相减倒转一下
        receiveList.sort(function (a, b) { return new Date(b["datetime"]) - new Date(a["datetime"]) });

        this.receiveLogs = receiveList;
        this.showReceiveLog = true;
      })
    }
  },
  computed: {
    getCurrentExchangeList() {

      return [];
      // return this.list
    }
  }
}
</script>

<style>
#v3CashOutDiv {
  position: relative;
  width: 100%;
  height: 70vh;
}

#v3CashOutContentDiv {
  position: absolute;
  display: flex;
  flex-direction: column;
}

#v3codTitleDiv {
  background-color: white;
  color: #3E3E3E;
  font-size: small;
  font-weight: bold;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #B4B4B4;
}

#v3ArrowDiv {
  position: absolute;
  float: left;
  height: 40px;
  display: flex;
  align-items: center;
}

#v3Arrow {
  height: 25px;
  width: 25px;
  object-fit: scale-down;
}

#v3RecordDiv {
  position: absolute;
  right: 2%;
  float: right;
  height: 40px;
  object-fit: scale-down;
  display: flex;
  align-items: center;
}

#v3Record {
  height: 14px;
  width: 53px;
}

#cashoutListDiv {
  overflow-y: auto;
  width: 100%;
  height: auto;
  max-height: 180px;

}

#v3Cashouv3ipDiv {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  padding-right: 10px;
}

#v3Cashouv3ipDiv span {
  font-size: xx-small;
  color: #9D9D9D;
}

#v3CashOutDiv button {
  margin-top: 5px;
  background: -webkit-linear-gradient(left, #FB6C34, #F84524);
  border-radius: 10px 10px 10px 10px;
  padding-top: 3px;
  padding-bottom: 3px;
  height: 30px;
  width: 94%;
  margin-left: 3%;
  color: white;
  font-size: small;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/views/SdkV3/mine/rebateTypeMoney/cashout/V3CashOut.vue